import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from "react-dnd-touch-backend";

// https://stackoverflow.com/a/4819886/1601953
const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);

export default DragDropContext(isTouchDevice ? TouchBackend : HTML5Backend);


// WEBPACK FOOTER //
// ./src/lib/dragdropcontext.js